// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    PlaceOfServiceType,
    PlaceOfServiceTypeFromJSON,
    PlaceOfServiceTypeToJSON,
    ProfessionalTemplateAmbulanceInformation,
    ProfessionalTemplateAmbulanceInformationFromJSON,
    ProfessionalTemplateAmbulanceInformationToJSON,
    ProfessionalTemplateAnesthesiaInformation,
    ProfessionalTemplateAnesthesiaInformationFromJSON,
    ProfessionalTemplateAnesthesiaInformationToJSON,
    ProfessionalTemplateDurableMedicalEquipmentInformation,
    ProfessionalTemplateDurableMedicalEquipmentInformationFromJSON,
    ProfessionalTemplateDurableMedicalEquipmentInformationToJSON,
    ProfessionalTemplateForm,
    ProfessionalTemplateFormFromJSON,
    ProfessionalTemplateFormToJSON,
    ProfessionalTemplateTestResult,
    ProfessionalTemplateTestResultFromJSON,
    ProfessionalTemplateTestResultToJSON,
    SupportChargemasterItem,
    SupportChargemasterItemFromJSON,
    SupportChargemasterItemToJSON,
    SupportFacility,
    SupportFacilityFromJSON,
    SupportFacilityToJSON,
    SupportProvider,
    SupportProviderFromJSON,
    SupportProviderToJSON,
    TemplateDrugInformation,
    TemplateDrugInformationFromJSON,
    TemplateDrugInformationToJSON,
    TemplatePaperwork,
    TemplatePaperworkFromJSON,
    TemplatePaperworkToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportProfessionalTemplateServiceLine
 */
export interface SupportProfessionalTemplateServiceLine {
    /**
     * The service line item id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    id?: string;
    /**
     * The from date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24aFromDateOfService: string;
    /**
     * The through date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24aThroughDateOfService?: string;
    /**
     * 
     * OpenAPI data type: {PlaceOfServiceType}
     * @type {PlaceOfServiceType}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24bPlaceOfServiceCode: PlaceOfServiceType;
    /**
     * Is this an emergency service
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24cEmergency?: boolean;
    /**
     * The procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24dProcedureCode: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24dProcedureModifiers?: Array<string>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24eDiagnosisPointers: Array<string>;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24fChargeAmount?: Amount;
    /**
     * Billable units
     * OpenAPI data type: {number}
     * @type {number}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    f24gUnits: number;
    /**
     * The line item control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12ControlNumber?: string;
    /**
     * Service line prior authorization number for the primary payer
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12PrimaryPayerPriorAuthorizationNumber?: string;
    /**
     * Service line prior authorization number for the secondary payer
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12SecondaryPayerPriorAuthorizationNumber?: string;
    /**
     * Service line prior authorization number for the tertiary payer
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12TertiaryPayerPriorAuthorizationNumber?: string;
    /**
     * Service narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Narrative?: string;
    /**
     * Required when in the judgement of the provider, the information is needed to substantiate the medical treatment and is not supported elsewhere within the claim data set.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Note?: string;
    /**
     * Service line level providers
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12ProviderIds?: Array<string>;
    /**
     * Service line level providers
     * OpenAPI data type: {array}
     * @type {Array<SupportProvider>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Providers?: Array<SupportProvider>;
    /**
     * The line item service facility.  Do not use for ambulance services rendered.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12FacilityId?: string;
    /**
     * 
     * OpenAPI data type: {SupportFacility}
     * @type {SupportFacility}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Facility?: SupportFacility;
    /**
     * 
     * OpenAPI data type: {ProfessionalTemplateDurableMedicalEquipmentInformation}
     * @type {ProfessionalTemplateDurableMedicalEquipmentInformation}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12DurableMedicalEquipment?: ProfessionalTemplateDurableMedicalEquipmentInformation;
    /**
     * Required on DMERC service lines to report patient height from the Certificate of Medical Necessity (CMN).  Use Height qualifier.
     * OpenAPI data type: {array}
     * @type {Array<ProfessionalTemplateTestResult>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12TestResults?: Array<ProfessionalTemplateTestResult>;
    /**
     * Required when there is a paper attachment following this claim
     * OpenAPI data type: {array}
     * @type {Array<TemplatePaperwork>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Paperwork?: Array<TemplatePaperwork>;
    /**
     * 
     * OpenAPI data type: {ProfessionalTemplateAmbulanceInformation}
     * @type {ProfessionalTemplateAmbulanceInformation}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Ambulance?: ProfessionalTemplateAmbulanceInformation;
    /**
     * 
     * OpenAPI data type: {ProfessionalTemplateAnesthesiaInformation}
     * @type {ProfessionalTemplateAnesthesiaInformation}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Anesthesia?: ProfessionalTemplateAnesthesiaInformation;
    /**
     * 
     * OpenAPI data type: {TemplateDrugInformation}
     * @type {TemplateDrugInformation}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Drug?: TemplateDrugInformation;
    /**
     * Required on all Medicare claims involving physician services to hospice patients.
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12HospiceEmployee?: boolean;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProfessionalTemplateForm>}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    x12Forms?: Array<ProfessionalTemplateForm>;
    /**
     * The chargemaster item id that enforces the information in the service line
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    chargemasterItemId?: string;
    /**
     * 
     * OpenAPI data type: {SupportChargemasterItem}
     * @type {SupportChargemasterItem}
     * @memberof SupportProfessionalTemplateServiceLine
     */
    chargemasterItem?: SupportChargemasterItem;
}

export function SupportProfessionalTemplateServiceLineFromJSON(json: any): SupportProfessionalTemplateServiceLine {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'f24aFromDateOfService': json['f24aFromDateOfService'],
            'f24aThroughDateOfService': !exists(json, 'f24aThroughDateOfService') ? undefined : json['f24aThroughDateOfService'],
            'f24bPlaceOfServiceCode': PlaceOfServiceTypeFromJSON(json['f24bPlaceOfServiceCode']),
            'f24cEmergency': !exists(json, 'f24cEmergency') ? undefined : json['f24cEmergency'],
            'f24dProcedureCode': json['f24dProcedureCode'],
            'f24dProcedureModifiers': !exists(json, 'f24dProcedureModifiers') ? undefined : json['f24dProcedureModifiers'],
            'f24eDiagnosisPointers': json['f24eDiagnosisPointers'],
            'f24fChargeAmount': !exists(json, 'f24fChargeAmount') ? undefined : AmountFromJSON(json['f24fChargeAmount']),
            'f24gUnits': json['f24gUnits'],
            'x12ControlNumber': !exists(json, 'x12ControlNumber') ? undefined : json['x12ControlNumber'],
            'x12PrimaryPayerPriorAuthorizationNumber': !exists(json, 'x12PrimaryPayerPriorAuthorizationNumber') ? undefined : json['x12PrimaryPayerPriorAuthorizationNumber'],
            'x12SecondaryPayerPriorAuthorizationNumber': !exists(json, 'x12SecondaryPayerPriorAuthorizationNumber') ? undefined : json['x12SecondaryPayerPriorAuthorizationNumber'],
            'x12TertiaryPayerPriorAuthorizationNumber': !exists(json, 'x12TertiaryPayerPriorAuthorizationNumber') ? undefined : json['x12TertiaryPayerPriorAuthorizationNumber'],
            'x12Narrative': !exists(json, 'x12Narrative') ? undefined : json['x12Narrative'],
            'x12Note': !exists(json, 'x12Note') ? undefined : json['x12Note'],
            'x12ProviderIds': !exists(json, 'x12ProviderIds') ? undefined : json['x12ProviderIds'],
            'x12Providers': !exists(json, 'x12Providers') ? undefined : (json['x12Providers'] as Array<any>).map(SupportProviderFromJSON),
            'x12FacilityId': !exists(json, 'x12FacilityId') ? undefined : json['x12FacilityId'],
            'x12Facility': !exists(json, 'x12Facility') ? undefined : SupportFacilityFromJSON(json['x12Facility']),
            'x12DurableMedicalEquipment': !exists(json, 'x12DurableMedicalEquipment') ? undefined : ProfessionalTemplateDurableMedicalEquipmentInformationFromJSON(json['x12DurableMedicalEquipment']),
            'x12TestResults': !exists(json, 'x12TestResults') ? undefined : (json['x12TestResults'] as Array<any>).map(ProfessionalTemplateTestResultFromJSON),
            'x12Paperwork': !exists(json, 'x12Paperwork') ? undefined : (json['x12Paperwork'] as Array<any>).map(TemplatePaperworkFromJSON),
            'x12Ambulance': !exists(json, 'x12Ambulance') ? undefined : ProfessionalTemplateAmbulanceInformationFromJSON(json['x12Ambulance']),
            'x12Anesthesia': !exists(json, 'x12Anesthesia') ? undefined : ProfessionalTemplateAnesthesiaInformationFromJSON(json['x12Anesthesia']),
            'x12Drug': !exists(json, 'x12Drug') ? undefined : TemplateDrugInformationFromJSON(json['x12Drug']),
            'x12HospiceEmployee': !exists(json, 'x12HospiceEmployee') ? undefined : json['x12HospiceEmployee'],
            'x12Forms': !exists(json, 'x12Forms') ? undefined : (json['x12Forms'] as Array<any>).map(ProfessionalTemplateFormFromJSON),
            'chargemasterItemId': !exists(json, 'chargemasterItemId') ? undefined : json['chargemasterItemId'],
            'chargemasterItem': !exists(json, 'chargemasterItem') ? undefined : SupportChargemasterItemFromJSON(json['chargemasterItem']),
    };

}

export function SupportProfessionalTemplateServiceLineToForm(value?: SupportProfessionalTemplateServiceLine): any {
    let jsonVal = SupportProfessionalTemplateServiceLineToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportProfessionalTemplateServiceLineToJSON(value?: SupportProfessionalTemplateServiceLine): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'f24aFromDateOfService': cleanupBlankValuesForBackend(value.f24aFromDateOfService),
            'f24aThroughDateOfService': cleanupBlankValuesForBackend(value.f24aThroughDateOfService),
            'f24bPlaceOfServiceCode': PlaceOfServiceTypeToJSON(value.f24bPlaceOfServiceCode),
            'f24cEmergency': cleanupBlankValuesForBackend(value.f24cEmergency),
            'f24dProcedureCode': cleanupBlankValuesForBackend(value.f24dProcedureCode),
            'f24dProcedureModifiers': cleanupBlankValuesForBackend(value.f24dProcedureModifiers),
            'f24eDiagnosisPointers': cleanupBlankValuesForBackend(value.f24eDiagnosisPointers),
            'f24fChargeAmount': AmountToJSON(value.f24fChargeAmount),
            'f24gUnits': cleanupBlankValuesForBackend(value.f24gUnits),
            'x12ControlNumber': cleanupBlankValuesForBackend(value.x12ControlNumber),
            'x12PrimaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.x12PrimaryPayerPriorAuthorizationNumber),
            'x12SecondaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.x12SecondaryPayerPriorAuthorizationNumber),
            'x12TertiaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.x12TertiaryPayerPriorAuthorizationNumber),
            'x12Narrative': cleanupBlankValuesForBackend(value.x12Narrative),
            'x12Note': cleanupBlankValuesForBackend(value.x12Note),
            'x12ProviderIds': cleanupBlankValuesForBackend(value.x12ProviderIds),
            'x12Providers': (value.x12Providers === undefined || value.x12Providers === null) ? undefined : (value.x12Providers as Array<any>).map(SupportProviderToJSON),
            'x12FacilityId': cleanupBlankValuesForBackend(value.x12FacilityId),
            'x12Facility': SupportFacilityToJSON(value.x12Facility),
            'x12DurableMedicalEquipment': ProfessionalTemplateDurableMedicalEquipmentInformationToJSON(value.x12DurableMedicalEquipment),
            'x12TestResults': (value.x12TestResults === undefined || value.x12TestResults === null) ? undefined : (value.x12TestResults as Array<any>).map(ProfessionalTemplateTestResultToJSON),
            'x12Paperwork': (value.x12Paperwork === undefined || value.x12Paperwork === null) ? undefined : (value.x12Paperwork as Array<any>).map(TemplatePaperworkToJSON),
            'x12Ambulance': ProfessionalTemplateAmbulanceInformationToJSON(value.x12Ambulance),
            'x12Anesthesia': ProfessionalTemplateAnesthesiaInformationToJSON(value.x12Anesthesia),
            'x12Drug': TemplateDrugInformationToJSON(value.x12Drug),
            'x12HospiceEmployee': cleanupBlankValuesForBackend(value.x12HospiceEmployee),
            'x12Forms': (value.x12Forms === undefined || value.x12Forms === null) ? undefined : (value.x12Forms as Array<any>).map(ProfessionalTemplateFormToJSON),
            'chargemasterItemId': cleanupBlankValuesForBackend(value.chargemasterItemId),
            'chargemasterItem': SupportChargemasterItemToJSON(value.chargemasterItem),
    };
}


